import { render, staticRenderFns } from "./addMiniGame.vue?vue&type=template&id=29de5ab8&lang=pug"
import script from "./addMiniGame.vue?vue&type=script&lang=js"
export * from "./addMiniGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports